module.exports = __webpack_public_path__ + "static/media/plus-nfg.c8067600.svg";